// container-specific styles
export const yellow = "yellow.300";
export const orange = "orange.400";
export const darkGray = "gray.700";
export const blue = "cyan.500";
export const green = "green.400";
export const largeFontSize = "16px";
export const normalFontSize = "12px";
export const smallerFontSize = "10px";

export const selectedTabStyle = {
  color: "white",
  bg: blue,
};
